/*
 * Makes the whole collection card open its collection.
 *
 * Dawn does this with a pseudo-element on the title link, but on this card variant its
 * positioning context is the text block, so the photo is never covered. Two CSS fixes for that
 * (an overlay element, then an anchor around the image) both failed here for reasons that were
 * never identified — the rules were served correctly and the click still did not land.
 *
 * A delegated click handler sidesteps the question entirely: whatever sits on top, the event
 * still bubbles to document, and the card's own title link supplies the destination.
 */
(function () {
  document.addEventListener('click', function (event) {
    var card = event.target.closest('.collection-card-wrapper');
    if (!card) return;

    // Let real links, buttons and form controls do their own thing.
    if (event.target.closest('a, button, input, select, textarea')) return;

    var link = card.querySelector('.card__heading a[href]');
    if (!link) return;

    // Honour the usual modifiers rather than hijacking every click.
    if (event.metaKey || event.ctrlKey || event.shiftKey || event.button !== 0) return;

    window.location.href = link.href;
  });
})();
